import { useEffect, useState } from 'react';

export const useSelected = (selected?: number) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  useEffect(() => {
    if (typeof selected === 'number') setSelectedIndex(selected);
  }, [selected]);

  const updateIndex = (index: number) => setSelectedIndex(index);

  return {
    index: selectedIndex,
    onClick: (index: number) => {
      setSelectedIndex(index);
    },
    updateIndex
  };
};
